document.addEventListener('click', event => {
 const thumb=event.target.closest('[data-nc-image]');
 if(thumb){const target=document.querySelector('#nc-main-image');if(target){event.preventDefault();target.src=thumb.dataset.ncImage;target.removeAttribute('srcset');target.alt=thumb.querySelector('img')?.alt||'';document.querySelectorAll('[data-nc-image]').forEach(t=>t.removeAttribute('aria-current'));thumb.setAttribute('aria-current','true');}}
});
document.addEventListener('change',event=>{
 if(event.target.matches('[data-nc-autosubmit]'))event.target.form.requestSubmit();
 if(event.target.id==='nc-variant'){
  const option=event.target.selectedOptions[0],button=document.querySelector('#nc-add'),price=document.querySelector('#nc-product-price');
  if(price)price.textContent=option.dataset.price;
  if(button){button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailable:button.dataset.label;}
  const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
 }
});
const ncZoom=document.querySelector('#nc5-lightbox');
if(ncZoom){
 const opener=document.querySelector('[data-nc-zoom]');
 opener?.addEventListener('click',()=>{const image=document.querySelector('#nc-main-image'),zoom=document.querySelector('#nc5-zoom-image');zoom.src=image.currentSrc||image.src;zoom.alt=image.alt;ncZoom.showModal();});
 ncZoom.querySelector('[data-nc-close]').addEventListener('click',()=>ncZoom.close());
 ncZoom.addEventListener('click',e=>{if(e.target===ncZoom)ncZoom.close();});
 ncZoom.addEventListener('close',()=>opener?.focus());
}
const ncBuyAnchor=document.querySelector('.nc5-buy-anchor'),ncPurchase=document.querySelector('#nc-purchase-form');
if(ncBuyAnchor&&ncPurchase){
 document.body.classList.add('nc5-product-page-active');
 const observer=new IntersectionObserver(entries=>{ncBuyAnchor.hidden=entries[0].isIntersecting;},{threshold:0});observer.observe(ncPurchase);
 document.querySelector('#nc-variant')?.addEventListener('change',e=>{document.querySelector('#nc5-sticky-price').textContent=e.target.selectedOptions[0].dataset.price;});
}
